<mat-card>
  <app-card-header
    title="Configurar comunicador"
    [subtitle]="data.nombre"
    icono="router"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <app-info-banner
      [icon]="'info'"
      [title]="'Proceso de configuración'"
      [message]="
        'Se enviará un SMS al comunicador que configurará:<br>
        • <strong>Conexión APN:</strong> usuario, contraseña y punto de acceso de la red móvil<br>
        • <strong>Envío de eventos:</strong> IP y puerto de la plataforma para recibir los eventos de la alarma<br><br>
        Asegurate de que los datos de la SIM sean correctos antes de enviar.'
      "
    ></app-info-banner>

    @if (!tieneSIMsValidas()) {
      <app-info-banner
        [icon]="'warning'"
        [title]="'Sin SIMs válidas'"
        [message]="
          'Cada SIM debe tener número de teléfono, APN, usuario y contraseña.<br>
          Configurá al menos una SIM antes de continuar.'
        "
        [color]="'red'"
      ></app-info-banner>
    }

    <!-- Datos del comunicador -->
    <app-content-card title="Datos del comunicador" icon="router">
      <div class="cc-datos">
        <span class="cc-etiqueta">ID comunicador</span>
        @if (this.data.idUnicoComunicador) {
          <span class="cc-valor">{{ this.data.idUnicoComunicador }}</span>
        } @else {
          <span class="no-info">Sin configurar</span>
        }
        <span class="cc-etiqueta">Contraseña comunicador</span>
        @if (this.data.comunicadores?.[0]?.passwordComunicador) {
          <span class="cc-valor">
            {{ this.data.comunicadores[0].passwordComunicador }}
          </span>
        } @else {
          <span class="no-info">Sin configurar</span>
        }
      </div>
    </app-content-card>

    <!-- SIMs -->
    <app-content-card title="Configuración de SIMs" icon="sim_card">
      <div class="cc-sims">
        @for (
          sim of [
            { nombre: 'SIM 1', datos: data.sim1 },
            { nombre: 'SIM 2', datos: data.sim2 },
          ];
          track sim.nombre
        ) {
          <div class="cc-sim" [class.cc-sim-invalida]="!esSimValida(sim.datos)">
            <div class="cc-sim-titulo">
              <mat-icon>sim_card</mat-icon>
              <span>{{ sim.nombre }}</span>
              @if (!esSimValida(sim.datos)) {
                <mat-icon class="cc-sim-alerta">warning</mat-icon>
              }
            </div>
            <div class="cc-datos">
              <span class="cc-etiqueta">Teléfono</span>
              @if (sim.datos?.numero) {
                <span class="cc-valor">{{ sim.datos.numero }}</span>
              } @else {
                <span class="no-info">Sin configurar</span>
              }
              <span class="cc-etiqueta">APN</span>
              @if (sim.datos?.apn) {
                <span class="cc-valor">{{ sim.datos.apn }}</span>
              } @else {
                <span class="no-info">Sin configurar</span>
              }
              <span class="cc-etiqueta">Usuario</span>
              @if (sim.datos?.usuario) {
                <span class="cc-valor">{{ sim.datos.usuario }}</span>
              } @else {
                <span class="no-info">Sin configurar</span>
              }
              <span class="cc-etiqueta">Contraseña</span>
              @if (sim.datos?.password) {
                <span class="cc-valor">{{ sim.datos.password }}</span>
              } @else {
                <span class="no-info">Sin configurar</span>
              }
            </div>
          </div>
        }
      </div>
    </app-content-card>

    <!-- Selección y envío -->
    @if (tieneSIMsValidas()) {
      <app-content-card
        title="Seleccionar SIM y enviar configuración"
        icon="send"
      >
        <section class="inputs-group">
          <!-- ng-select emite la SIM elegida (objeto entero), no { value } -->
          <ng-select
            style="width: 100%"
            placeholder="SIM a utilizar"
            [items]="simsValidas()"
            [searchFn]="buscarSim"
            (change)="selected.set($event)"
            appendTo="body"
            notFoundText="Sin resultados"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.numero }} - {{ item.apn }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.numero }} - {{ item.apn }}
            </ng-template>
          </ng-select>
        </section>

        @if (mensajePreview()) {
          <div class="cc-preview">
            <span class="cc-etiqueta">Vista previa del mensaje SMS</span>
            <pre>{{ mensajePreview() }}</pre>
          </div>
        }

        @if (error()) {
          <app-info-banner
            [icon]="'error'"
            [title]="'Error de validación'"
            [message]="error()"
            [color]="'red'"
            [margin]="'12px 0 0 0'"
          ></app-info-banner>
        }
      </app-content-card>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
      Cancelar
    </button>
    <button
      irxBoton="principal"
      type="button"
      (click)="enviarConfig()"
      [disabled]="!selected() || loading() || !valid()"
    >
      <mat-icon>send</mat-icon>
      Enviar SMS
    </button>
  </mat-card-actions>
</mat-card>
